// extracted by mini-css-extract-plugin
module.exports = {"grid":"seance-grid_grid__1125T","minWidth":"seance-grid_minWidth__2c4BG"};